import React from "react";
import PT from "prop-types";
import * as S from "./styled";
import { Link } from "react-router-dom";
import Avatar from "_c/Avatar";
import { LinkGenerator } from "@/utils/LinkGenerator";
import moment from "moment";

const Comment = ({
  comment,
  onRemove,
  isOwner,
  insertNameIntoInput,
  isAuth,
  t,
}) => {
  const { author } = comment;
  const fullName = [author.first_name, author.last_name]
    .filter(Boolean)
    .join(" ");
  return (
    <S.Wrap>
      <Link
        title={fullName}
        to={
          author.master
            ? LinkGenerator.masterProfile(author.master)
            : LinkGenerator.clientProfile(author._id)
        }
      >
        <Avatar avatar={author.avatar} sex={author.sex} size="md" />
      </Link>
      <S.RightPart>
        <S.Author>{fullName}</S.Author>
        <S.Date>{moment(comment.created_at).calendar()}</S.Date>
        <S.Text>{comment.text}</S.Text>
        <S.Buttons>
          {isAuth && !isOwner && (
            <S.ResponseButton onClick={() => insertNameIntoInput(fullName)}>
              {t("common:respond")}
            </S.ResponseButton>
          )}
          {isOwner && (
            <S.RemoveButton onClick={() => onRemove(comment._id)}>
              {t("common:remove")}
            </S.RemoveButton>
          )}
        </S.Buttons>
      </S.RightPart>
    </S.Wrap>
  );
};
Comment.propTypes = {
  isAuth: PT.bool,
  comment: PT.object,
  isOwner: PT.bool,
  insertNameIntoInput: PT.func,
  onRemove: PT.func,
};

export default Comment;
